import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { get_grados } from "../services/api";
import { UseSetLenguajePorPais } from '../hooks/UseSetLenguajePorPais';
import { useTranslation } from 'react-i18next';

export default function GetGrados({ onGradoChange, selectedGrado }) {
  const [data, setData] = useState([]);
  const { t } = useTranslation(); // Hook de traducción

  //Hook para lenguaje según país
  UseSetLenguajePorPais();

  useEffect(() => {
    async function ObtenerDatosDeAPI() {
      try {
        const { data, status } = await get_grados();
        if (status === 200) {
          const datos = data;
          const gradosArray = Object.entries(datos).map(([id, nombre]) => ({
            id,
            nombre,
          }));
          setData(gradosArray);
        } else {
          console.error('La solicitud a la API no fue exitosa.');
        }
      } catch (error) {
        console.error('Se produjo un error al realizar la solicitud a la API:', error);
      }
    }

    ObtenerDatosDeAPI();
  }, []);

  const handleGradoChange = (event) => {
    const selectedGradoId = event.target.value;
    const nameSelectedGrado = data.find((grado) => grado.id === selectedGradoId);
    onGradoChange(nameSelectedGrado);
  };


  return (
    <Grid item xs={12}>
      <Box>
        <Typography 
          sx={{ fontFamily: 'montserrat', fontSize: '1rem', fontWeight: 'bold', color: '#336B87' }}
        >
          {t('nivel')}
        </Typography>
        <FormControl fullWidth>
          <Select
            labelId="select-subject"
            placeholder="Selecciona un grado..."
            id="select-subject"
            variant="outlined"
            displayEmpty
            value={selectedGrado || ''} // Aquí se asigna el valor desde el prop
            onChange={handleGradoChange}
            sx={{
              fontFamily: "montserrat",
              fontSize: "14px",
              borderRadius: 2,
              "& .MuiOutlinedInput-root": { borderRadius: 2 },
              "& fieldset": { borderColor: "#BDBDBD" },
              "&:hover fieldset": { borderColor: "#9E9E9E" },
              "&.Mui-focused fieldset": { borderColor: "#005559" },
              "& .MuiSelect-select": {
                color: selectedGrado ? "#005559" : "#B3D1D1",
              },
            }}
          >
            <option hidden value="">
              Selecciona hasta 1 opción máximo. Ejemplo: 5° básico 
            </option>
            {data.map((grado) => (
              <MenuItem key={grado.id} value={grado.id} sx={{ color: '#336B87' }}>
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '0.8rem', color: '#336B87' }}>
                  {grado.nombre}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Grid>
  );
}
